import { api_GET } from "./_api.js";
// import { getSessionCookie } from "../helpers/cookies.js";

const dashboard_api = {
  GetDashboard: () => {
    const promise = new Promise((resolve, reject) => {
      api_GET("Dashboard").then(result => {
        resolve(result);
      }).catch(e => {
        reject(e);
      });
    });
    return promise;
  },
  GetListIntegracaoFalha: () => {
    const promise = new Promise((resolve, reject) => {
      api_GET("Dashboard/GetListIntegracaoFalha").then(result => {
        resolve(result);
      }).catch(e => {
        reject(e);
      });
    });
    return promise;
  },
  GetInfracaoPendenteVotocao: () => {
    const promise = new Promise((resolve, reject) => {
      api_GET("Dashboard/GetInfracaoPendenteVotocao").then(result => {
        resolve(result);
      }).catch(e => {
        reject(e);
      });
    });
    return promise;
  }
}

export default dashboard_api;
